import { Link } from "react-router-dom";
import { formatPrice, relativeTime } from "../lib/format";
import { categoryLabel } from "../lib/categories";

export function ListingCard({ listing }) {
  const cover = listing.coverThumb || listing.photos && listing.photos[0];
  const sold = listing.status === "sold";

  return (
    <Link
      to={`/gear/listing/${listing.id}`}
      className="group block bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-md hover:border-slate-300 transition"
    >
      <div className="relative aspect-square bg-slate-100">
        {cover ? (
          <img
            src={cover}
            alt={listing.title}
            loading="lazy"
            className="h-full w-full object-cover group-hover:scale-[1.02] transition-transform"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center bg-slate-100 text-5xl opacity-40">
            ⚽
          </div>
        )}
        {sold && (
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
            <span className="text-white font-bold text-lg tracking-wide rotate-[-8deg] border-2 border-white px-3 py-1 rounded">
              SOLD
            </span>
          </div>
        )}
        <span className="absolute top-2 left-2 bg-white/90 backdrop-blur text-xs font-medium text-slate-600 px-2 py-0.5 rounded-full">
          {categoryLabel(listing.category)}
        </span>
      </div>
      <div className="p-3">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-semibold text-slate-800 leading-snug line-clamp-2">
            {listing.title}
          </h3>
          <span className="shrink-0 font-bold text-brand-700">{formatPrice(listing.price)}</span>
        </div>
        <div className="mt-1 flex items-center justify-between text-xs text-slate-400">
          <span className="truncate">{listing.sellerName}</span>
          <span className="shrink-0">{relativeTime(listing.createdAt)}</span>
        </div>
      </div>
    </Link>
  );
}
